import { render, staticRenderFns } from "./index-modal.vue?vue&type=template&id=40260f9a&"
import script from "./index-modal.vue?vue&type=script&lang=js&"
export * from "./index-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40260f9a')) {
      api.createRecord('40260f9a', component.options)
    } else {
      api.reload('40260f9a', component.options)
    }
    module.hot.accept("./index-modal.vue?vue&type=template&id=40260f9a&", function () {
      api.rerender('40260f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/aboutus/giontsujiri/index-modal.vue"
export default component.exports